<div class="grid grid-cols-4 gap-2 lg:gap-4">
	@for (item of OB.item_desc; track $index; let i = $index) {
		<ng-container [formGroup]="obFormGroup">
			@if (getOb(i)) {
				<div class="relative">
					<div
						class="ob-box h-full rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
						[class.cursor-pointer]="!readOnly"
						[class.cursor-default]="readOnly"
						[class.activeGrid]="getOb(i).currentCount > 0"
						[class.added]="getOb(i).lastSavedAction === OB_LAST_ACTION.ADDED"
						[class.removed]="getOb(i).lastSavedAction === OB_LAST_ACTION.REMOVED"
						[class.disabled]="getOb(i).isDisabled === true"
					>
						<div class="mb-2 flex flex-row justify-between">
							<!-- Title and OB Count/Attempt -->
							<div class="gap flex flex-row items-center gap-1 lg:gap-2">
								<span class="grid-title text-sm font-bold lg:text-lg">{{ item.name }}</span>
								@if (getOb(i).currentCount > 0 || getOb(i).totalCount > 0) {
									<span class="ob-attempt text-[9px] lg:text-xs"
										>[{{ getOb(i).currentCount }}/{{ getOb(i).totalCount }}]</span
									>
								}
							</div>
							@if (showButtons && !readOnly) {
								<div class="gap flex flex-row gap-1 lg:gap-4">
									<button
										type="button"
										[class.opacity-50]="disableRemove(i)"
										[disabled]="disableRemove(i)"
										class="attemptBtn removeBtn flex h-[16px] w-[16px] items-center justify-center rounded-sm lg:h-[24px] lg:w-[24px] lg:rounded-lg"
										(click)="removeAttempt(OB.title, i)"
									>
										-
									</button>

									<button
										type="button"
										[class.opacity-50]="disableAdd(i)"
										[disabled]="disableAdd(i)"
										class="attemptBtn addBtn flex h-[16px] w-[16px] items-center justify-center rounded-sm lg:h-[24px] lg:w-[24px] lg:rounded-lg"
										(click)="addAttempt(OB.title, i)"
									>
										+
									</button>
								</div>
							}
						</div>
						<p class="grid-description text-black">
							{{ item.description }}
						</p>
					</div>
					@if (getOb(i).preDefined) {
						<div class="absolute bottom-[10px] right-[10px]">
							<img src="/assets/predefined_stars.png" title="" alt="" />
						</div>
					}
				</div>
			}
		</ng-container>
	}
</div>
